import { SectionDetail } from "../components/feature/Order";

export default function OrderDetail()
{
    return(
        <>
        <SectionDetail/>
        </>
    );
}